import React, { useEffect, useMemo, useRef } from 'react';

import { Platform, Pressable, View } from 'react-native';

import { useTranslation } from 'react-i18next';

import CheckmarkIcon from 'assets/images/svgs/ico_checkmark.svg';

import { LANGUAGE_KEYS } from 'config/languageKeys';

import setAccessibilityFocusTo from 'services/accessibility/setAccessibilityFocusTo';

import { COLOR } from 'utils/colors';
import { isWeb } from 'utils/responsiveness';

import Text, { ETextCategory, ETextColor } from 'components/Text';

import styles from './styles';

type Props = {
    label: string;
    isSelected: boolean;
    onSelect: () => void;
    testID: string;
    index: number;
};

const {
    ACCESSIBILITY: {
        ACCESSIBILITY_GENERAL_TAPP_TWICE,
        ACCESSIBILITY_GENERAL_TAPP_TWICE_WEB,
    },
} = LANGUAGE_KEYS;

const SelectAgeRatingItem = ({
    label,
    isSelected,
    onSelect,
    testID,
    index,
}: Props) => {
    const { t } = useTranslation();
    const ageRatingRef = useRef<View>(null);

    useEffect(() => {
        if (index === 0 && isWeb) {
            setAccessibilityFocusTo(ageRatingRef);
        }
    }, [index]);

    const accessibilityLabel = useMemo(
        () =>
            `${label} ${isWeb ? t(ACCESSIBILITY_GENERAL_TAPP_TWICE_WEB) : ''}`,
        [t],
    );

    return (
        <Pressable
            ref={ageRatingRef}
            style={styles.itemContainer}
            onPress={onSelect}
            testID={testID}
            accessibilityLabel={accessibilityLabel}
            accessibilityRole="button"
            {...(Platform.OS === 'ios' && {
                accessibilityHint: t(ACCESSIBILITY_GENERAL_TAPP_TWICE),
            })}
            accessible
            aria-selected={isSelected}
        >
            <Text category={ETextCategory.body1} color={ETextColor.neutral}>
                {label}
            </Text>
            {isSelected ? <CheckmarkIcon fill={COLOR.NEUTRAL} /> : null}
        </Pressable>
    );
};

export default SelectAgeRatingItem;
